// @flow
import PageDetail from 'components/page/PageDetail';
import { connect } from 'react-redux';
import { fetchPageDetailPreview } from 'actions/pageActions';

import type { DispatchType, StateType } from 'types/Actions';
import type { DispatchProps, StateProps } from 'components/page/PageDetail';

export default connect(
  (state: StateType): StateProps => ({
    title: state.pageDetailState.title ? 
      state.pageDetailState.title : state.pageDetailPreviewState.title,
    content: state.pageDetailState.content.length > 0 ? 
      state.pageDetailState.content : state.pageDetailPreviewState.content,
    status: state.pageDetailState.status ? 
      state.pageDetailState.status : state.pageDetailPreviewState.status,
    documents: state.pageDetailState.documents ? 
      state.pageDetailState.documents : state.pageDetailPreviewState.documents,
    membersGroups: state.pageDetailState.membersGroups ? 
      state.pageDetailState.membersGroups : state.pageDetailPreviewState.membersGroups,
    departmentsGroups: state.pageDetailState.departmentsGroups ? 
      state.pageDetailState.departmentsGroups : state.pageDetailPreviewState.departmentsGroups,
    arbitresGroups: state.pageDetailState.arbitresGroups ? 
      state.pageDetailState.arbitresGroups : state.pageDetailPreviewState.arbitresGroups,
    academies: state.pageDetailState.academies ? 
      state.pageDetailState.academies : state.pageDetailPreviewState.academies,
    meta_description: state.pageDetailState.meta_description ? 
      state.pageDetailState.meta_description : state.pageDetailPreviewState.meta_description,
    meta_title: state.pageDetailState.meta_title ? 
      state.pageDetailState.meta_title : state.pageDetailPreviewState.meta_title,
    template: state.pageDetailState.template ? 
      state.pageDetailState.template : state.pageDetailPreviewState.template,
    contentNode: state.pageDetailState.content ? 
      state.pageDetailState.content : state.pageDetailPreviewState.content,
    liste_enfants: state.pageDetailState.liste_enfants ? 
      state.pageDetailState.liste_enfants : state.pageDetailPreviewState.liste_enfants,
    redirection: state.pageDetailState.redirection ? 
      state.pageDetailState.redirection : state.pageDetailPreviewState.redirection,
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchPageDetailPreview: (id: number) => dispatch(fetchPageDetailPreview(id)),
  })
)(PageDetail);
